module.exports = __webpack_public_path__ + "img/首页背景图.83d17148.png";